import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import LineOnSideHeader from '~/components/atoms/LineOnSideHeader.vue';
import RatingStars from '~/components/molecules/Global/RatingStars.vue';

var MdmModal = () => import(
/* webpackChunkName: "modal" */
'~/components/atoms/Global/MdmModal.vue');

var ProductStock = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/atoms/Product/ProductStock.vue');

export default {
  name: 'ProductOffersModal',
  components: {
    MdmModal,
    LineOnSideHeader,
    RatingStars,
    ProductStock
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    offers: {
      type: Object,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      items: null
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    discountDeadline() {
      return '20/02/2020';
    }

  }),
  methods: {
    merchantUrl(reference) {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/m/").concat(reference);
    },

    currentPrice(offer) {
      if (offer.product.price.sales.amount) {
        return offer.product.price.sales.formatted;
      }

      return offer.product.price.base.formatted;
    }

  }
};